import { Box, BoxProps, LinearProgress, Typography } from "@mui/material";
import { FC } from "react";
import { makeStyles } from "tss-react/mui";

interface CourseProgressionSummaryProps extends BoxProps {
	/** Course title (when provided, shown like shapeshift-common CourseProgressionSummary) */
	title?: string;
	percentComplete: number;
	completedModules: number;
	totalModules: number;
}

// Styles and layout aligned with @buildwitt/shapeshift-common v1 courseProgressionSummary
const useStyles = makeStyles()((theme) => ({
	courseProgressionSummary: {
		marginBottom: "25px",
		overflow: "hidden",
	},
	courseTitle: {
		color: "white",
		marginBottom: "10px",
		fontSize: "16px",
		[theme.breakpoints.down("sm")]: {
			fontSize: "18px",
		},
	},
	progressContainer: {
		color: "white",
	},
	percentLabel: {
		display: "inline-block",
	},
	progressBar: {
		marginRight: "15px",
		display: "inline-block",
		padding: 0,
		border: "none",
		width: "calc(100% - 60px)",
	},
}));

/**
 * Course Progression Summary
 *
 * Displays course title (optional), progress bar and percent.
 * Layout and styles match @buildwitt/shapeshift-common v1 courseProgressionSummary.
 */
export const CourseProgressionSummary: FC<CourseProgressionSummaryProps> = ({
	className,
	title,
	percentComplete,
	completedModules,
	totalModules,
	...props
}) => {
	const { classes, cx } = useStyles();

	return (
		<Box className={cx(classes.courseProgressionSummary, className)} {...props}>
			{title && (
				<Typography variant="body1" className={classes.courseTitle}>
					{title}
				</Typography>
			)}
			<Box className={classes.progressContainer}>
				<LinearProgress
					variant="determinate"
					className={classes.progressBar}
					value={percentComplete}
				/>
				<Typography className={classes.percentLabel} variant="body1">
					{percentComplete}%
				</Typography>
			</Box>
		</Box>
	);
};

export default CourseProgressionSummary;

